import styled from "@emotion/styled";
// @ts-expect-error
import units from "design-units";
import { Modal as ModalUI } from "@material-ui/core";

export const Modal = styled(ModalUI)`
  display: flex;
  align-items: center;
  justify-content: center;

  .modalDialogContainer {
    box-shadow: 0px 3px 5px -1px rgb(0 0 0 / 20%), 0px 5px 8px 0px rgb(0 0 0 / 14%),
      0px 1px 14px 0px rgb(0 0 0 / 12%);
    padding: 16px 32px 24px;
    position: relative;
    max-width: 90%;
    font-family: ${(props) => props.theme.fontFamily.primary};
    ${units({
      backgroundColor: "white",
      color: "grey",
    })};

    .closeButton {
      position: absolute;
      font-size: 3rem;
      right: 1.5rem;
    }
    &.small {
      width: 650px;
    }
    &.medium {
      width: 850px;
    }
    &.large {
      width: 1100px;
    }
  }
  @media (max-width: 600px) {
    width: 100%;

    div:not(.MuiBackdrop-root) {
      width: 96%;
    }
  }
`;

export const SearchContainer = styled.div`
  padding: 2rem 1rem;
  ${units({
    backgroundColor: "lighterGrey",
  })};
`;

export const BorderedContainer = styled.div`
  border: 1px solid;
  border-radius: 8px;
  overflow: hidden;
  ${units({
    borderColor: "lightGrey",
  })};
`;

export const ListContainer = styled.div`
  padding: 2rem;
  height: 400px;
  overflow: auto;
`;
